// extracted by mini-css-extract-plugin
module.exports = {"container":"NewsTagListPage_container__334nA"};